export default {
  name: 'cco:ProductResourcesCard',
  title: 'Card with resources to get to know more about the product ',
  owner: 'System',
  solution: '',
  tags: ['widget', 'card', 'get to know', 'resource'],
  createdAt: 'Feb 23, 2024, 10:14 AM',
  updatedAt: 'Feb 27, 2024, 9:59 PM',
  spec: {
    props: {
      title: 'Card Title',
      type: 'Card Type',
      resource1Title: 'Resource 1 Title',
      resource1ClickHandler: 'Resource 1 Link',
      resource1IconType: 'Resource 1 Icon Type',
      resource1Icon: 'Resource 1 Icon',
      resource2Title: 'Resource 2 Title',
      resource2ClickHandler: 'Resource 2 Link',
      resource2IconType: 'Resource 2 Icon Type',
      resource2Icon: 'Resource 2 Icon',
      resource3Title: 'Resource 3 Title',
      resource3ClickHandler: 'Resource 3 Link',
      resource3IconType: 'Resource 3 Icon Type',
      resource3Icon: 'Resource 3 Icon',
      closeHandler: 'Close handler',
    },
    view: [
      {
        instanceOf: 'div',
        className: '${ "flex-col items-start self-stretch w-[33%]" }',
        children: [
          [
            'div',
            {
              '.': 'bg-default-bg-weak p-5 rounded-xl mr-3 h-full',
              style: {
                boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.08)',
              },
            },
            [
              [
                'div',
                {
                  '.': 'flex w-full justify-between pb-3',
                  style: { font: 'var(--typography-heading-sub-section)', color: 'var(--default-text-strong)' },
                },
                [
                  ['div', {}, '/${ props.title }'],
                  [
                    'div',
                    {
                      '.': 'hover:cursor-pointer',
                    },
                    [
                      [
                        'uik:Icon.Action.Disable',
                        {
                          size: 'SMALL',
                          onClick: '/${ props.closeHandler }',
                        },
                      ],
                    ],
                  ],
                ],
              ],
              [
                'div',
                {
                  '.': 'flex p-5',
                },
                [
                  [
                    'dashify:If',
                    {
                      condition: '/${ props.resource1IconType = "image" }',
                    },
                    [
                      [
                        'dashify:Then',
                        {},
                        [
                          [
                            'img',
                            {
                              src: '/${ props.resource1Icon }',
                              height: '12.75px',
                              width: '24px',
                            },
                          ],
                        ],
                      ],
                      [
                        'dashify:Else',
                        {},
                        [
                          [
                            'uik:Icon',
                            {
                              size: 'SMALL',
                              type: '/${ props.resource1Icon }',
                            },
                          ],
                        ],
                      ],
                    ],
                  ],
                  [
                    'div',
                    {
                      '.': 'hover:cursor-pointer no-underline ml-3',
                      style: {
                        font: 'var(--typography-p3-bold)',
                        color: 'var(--interact-text)',
                        '&:hover': {
                          color: 'var(--interact-text)',
                        },
                      },
                      onClick: '/${ props.resource1ClickHandler }',
                    },
                    '/${ props.resource1Title }',
                  ],
                ],
              ],
              ['div', { '.': 'flex-col self-stretch items-start bg-control-border-weak h-px' }],
              [
                'div',
                {
                  '.': 'flex p-5',
                },
                [
                  [
                    'dashify:If',
                    {
                      condition: '/${ props.resource2IconType = "image" }',
                    },
                    [
                      [
                        'dashify:Then',
                        {},
                        [
                          [
                            'img',
                            {
                              src: '/${ props.resource2Icon }',
                              height: '12.75px',
                              width: '24px',
                            },
                          ],
                        ],
                      ],
                      [
                        'dashify:Else',
                        {},
                        [
                          [
                            'uik:Icon',
                            {
                              size: 'SMALL',
                              type: '/${ props.resource2Icon }',
                            },
                          ],
                        ],
                      ],
                    ],
                  ],
                  [
                    'div',
                    {
                      '.': 'hover:cursor-pointer no-underline ml-3',
                      style: {
                        font: 'var(--typography-p3-bold)',
                        color: 'var(--interact-text)',
                        '&:hover': {
                          color: 'var(--interact-text)',
                        },
                      },
                      onClick: '/${ props.resource2ClickHandler }',
                    },
                    '/${ props.resource2Title }',
                  ],
                ],
              ],
              ['div', { '.': 'flex-col self-stretch items-start bg-control-border-weak h-px' }],
              [
                'div',
                {
                  '.': 'flex p-5',
                },
                [
                  [
                    'dashify:If',
                    {
                      condition: '/${ props.resource3IconType = "image" }',
                    },
                    [
                      [
                        'dashify:Then',
                        {},
                        [
                          [
                            'img',
                            {
                              src: '/${ props.resource3Icon }',
                              height: '12.75px',
                              width: '24px',
                            },
                          ],
                        ],
                      ],
                      [
                        'dashify:Else',
                        {},
                        [
                          [
                            'uik:Icon',
                            {
                              size: 'SMALL',
                              type: '/${ props.resource3Icon }',
                            },
                          ],
                        ],
                      ],
                    ],
                  ],
                  [
                    'div',
                    {
                      '.': 'hover:cursor-pointer no-underline ml-3',
                      style: {
                        font: 'var(--typography-p3-bold)',
                        color: 'var(--interact-text)',
                        '&:hover': {
                          color: 'var(--interact-text)',
                        },
                      },
                      onClick: '/${ props.resource3ClickHandler }',
                    },
                    '/${ props.resource3Title }',
                  ],
                ],
              ],
            ],
          ],
        ],
      },
    ],
  },
};
